import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from 'tss-react/mui'
import { StackItem } from 'ui/layout/StackItem'
import { MedicalInstitutionProps, PublicInformation } from 'types/med'

const useStyles = makeStyles()(() => ({
  freeDescription: {
    whiteSpace: 'pre-wrap',
  },
}))

const PublicInformationSection: React.FC<{
  med: MedicalInstitutionProps
  publicInformation?: PublicInformation
}> = ({ med, publicInformation }) => {
  const { t } = useTranslation()
  const { classes } = useStyles()
  return (
    <>
      {!publicInformation?.is_request ? (
        <StackItem label={t('情報掲載')}>{t('希望しない')}</StackItem>
      ) : (
        <>
          <StackItem label={t('情報掲載')}>{t('希望する')}</StackItem>
          <StackItem label={t('施設名')}>{med.name}</StackItem>
          <StackItem label={t('電話番号')}>{med.phone}</StackItem>
          <StackItem label={t('住所')}>
            {[
              `〒${med.postal_code}`,
              med.prefecture,
              med.city,
              med.town,
              med.street,
              med.building,
            ].join(' ')}
          </StackItem>
          <StackItem label={t('管理者氏名')}>
            {publicInformation.contact_name}
          </StackItem>
          <StackItem label={t('ウェブサイトURL')}>
            {publicInformation.institution_url || t('未設定')}
          </StackItem>
          <StackItem label={t('オンライン診療初診対応')}>
            {publicInformation.is_possible_first_visit ? t('可') : t('不可')}
          </StackItem>
          <StackItem label={t('分類')}>
            {publicInformation.classification || t('未設定')}
          </StackItem>
          <StackItem label={t('特徴')}>
            {publicInformation.characteristic || t('未設定')}
          </StackItem>
          <StackItem label={t('メッセージ')}>
            {publicInformation.message || t('未設定')}
          </StackItem>
          <StackItem label={t('予約方法')} alignTop>
            <div className={classes.freeDescription}>
              {publicInformation.reservation_method === '自由記述'
                ? publicInformation.reservation_method_free_description
                : publicInformation.reservation_method}
            </div>
          </StackItem>
        </>
      )}
    </>
  )
}

export default PublicInformationSection
